import EditForm from "../Components/EditForm";

export default function index() {
    return (
        <div>
        <h2>Edit Page</h2>
        <EditForm />
        </div>
    );
};
